
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.47.336C7.337.336 3.591 2.596.827 6.267a.856.856 0 000 1.022c2.764 3.676 6.51 5.936 10.641 5.936s7.877-2.26 10.642-5.931a.856.856 0 000-1.022C19.346 2.597 15.6.336 11.469.336zm.296 10.982A4.55 4.55 0 016.93 6.484a4.558 4.558 0 014.242-4.241 4.55 4.55 0 014.834 4.834c-.146 2.26-1.981 4.095-4.241 4.241zm-.137-2.096a2.445 2.445 0 01-2.601-2.6 2.459 2.459 0 012.287-2.287 2.445 2.445 0 012.6 2.6 2.459 2.459 0 01-2.286 2.287z"}})])
          )
        }
      }
    